import React, { forwardRef, useMemo } from 'react'
import type {
  CSSProperties,
  DetailedHTMLProps,
  HTMLAttributes,
  PropsWithChildren,
} from 'react'

import './Tinted.scss'

//
// Tinted
//
// The tinted component is an important part of your toolkit when dealing with
// elements within the webinar room that needs to have a tint of a custom
// template color. Making this your bread and butter for when you pass it a tint
// and an opacity (which is 0.1 as default), you will get a tint of that color
// on whichever background you have added through your own styling to this
// component.
//
// Otherwise no modifications are made and this component should be trated like
// a normal div element.
//

interface TintedProps
  extends PropsWithChildren<
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
  > {
  tint?: string
  opacity?: number
}

// eslint-disable-next-line react/display-name
const Tinted = forwardRef<HTMLDivElement, TintedProps>(
  ({ tint, opacity, className, ...props }: TintedProps, ref) => {
    const style = useMemo(() => {
      return {
        '--tinted-tint': tint ?? 'transparent',
        '--tinted-opacity': opacity ?? 0.1,
      } as CSSProperties
    }, [tint, opacity])

    const classNames = ['tinted', className].join(' ')

    return <div ref={ref} {...props} className={classNames} style={style} />
  }
)

export { Tinted }
